import { render, staticRenderFns } from "./AllDocuments.vue?vue&type=template&id=22c66003&scoped=true"
import script from "./AllDocuments.vue?vue&type=script&lang=js"
export * from "./AllDocuments.vue?vue&type=script&lang=js"
import style0 from "./AllDocuments.vue?vue&type=style&index=0&id=22c66003&prod&lang=scss&scoped=true"
import style1 from "./AllDocuments.vue?vue&type=style&index=1&id=22c66003&prod&lang=scss"
import style2 from "./AllDocuments.vue?vue&type=style&index=2&id=22c66003&prod&lang=css"
import style3 from "./AllDocuments.vue?vue&type=style&index=3&id=22c66003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c66003",
  null
  
)

export default component.exports